var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_2467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.367188 4.39681C0.367188 2.48197 1.91947 0.929688 3.83431 0.929688H38.5055C40.4203 0.929688 41.9726 2.48197 41.9726 4.39681V25.1995C41.9726 27.1144 40.4203 28.6666 38.5055 28.6666H3.83431C1.91947 28.6666 0.367188 27.1144 0.367188 25.1995V4.39681Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4543 8.58804L17.6826 8.61133L17.8878 21.0086L24.6595 20.9853L24.4543 8.58804Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1276 14.8351C18.0857 12.3136 19.2152 10.0731 20.9845 8.61985C19.649 7.57192 17.9748 6.94175 16.1599 6.94797C11.8604 6.9627 8.4405 10.5047 8.51301 14.868C8.58552 19.2313 12.1227 22.7495 16.4223 22.7347C18.2372 22.7285 19.8902 22.087 21.1907 21.03C19.3737 19.611 18.1695 17.3566 18.1276 14.8351Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8278 14.7292C33.9003 19.0925 30.4805 22.6345 26.1809 22.6493C24.366 22.6555 22.6918 22.0253 21.3564 20.9774C23.1472 19.524 24.2551 17.2837 24.2132 14.7622C24.1713 12.2407 22.9675 10.0082 21.1501 8.56722C22.4506 7.51025 24.1037 6.86869 25.9186 6.86248C30.2181 6.84775 33.7557 10.3879 33.8278 14.7292Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_2467"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.367188,
    y: 0.929688,
    width: 41.6054,
    height: 27.737,
    rx: 5.77853,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6d7981e4f274036b0fd6bc1bea38762f.svg";
export { ForwardRef as ReactComponent };